import { render } from "./Action.vue?vue&type=template&id=1ca5dad1&scoped=true"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"

import "./Action.vue?vue&type=style&index=0&id=1ca5dad1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca5dad1"],['__file',"src/common/components/Action/Action.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ca5dad1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ca5dad1', __exports__)) {
    api.reload('1ca5dad1', __exports__)
  }
  
  module.hot.accept("./Action.vue?vue&type=template&id=1ca5dad1&scoped=true", () => {
    api.rerender('1ca5dad1', render)
  })

}


export default __exports__